module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/medicine_bow_national_forest-4a8ad59734ffd3919dc8d5efab015a90.jpg";